import { render } from "./P090.vue?vue&type=template&id=f01bb3d0&scoped=true"
import script from "./P090.vue?vue&type=script&lang=js"
export * from "./P090.vue?vue&type=script&lang=js"

import "./P090.vue?vue&type=style&index=0&id=f01bb3d0&scoped=true&lang=css"

import exportComponent from "/home/sage/workspace/sageprice-dev/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-f01bb3d0"]])

export default __exports__